import axios from "axios";
import { stripHtmlToText } from "./stripHtmlToText";

const previewCache = new Map();
const loadingPromises = new Map();
const previewListeners = new Set();

function notifyPreviewListeners() {
  previewListeners.forEach((listener) => listener());
}

export function subscribeDocumentPreviewUpdates(listener) {
  previewListeners.add(listener);
  return () => previewListeners.delete(listener);
}

export function getCachedDocumentPreview(documentName) {
  return previewCache.get(documentName) || "";
}

export async function loadDocumentPreview(documentName) {
  if (!documentName) return "";

  if (previewCache.has(documentName)) {
    return previewCache.get(documentName);
  }

  if (loadingPromises.has(documentName)) {
    return loadingPromises.get(documentName);
  }

  const promise = axios
    .get("/api/admin/lexical/retrieve-member-html-document", {
      params: { documentName },
      withCredentials: true,
    })
    .then((response) => {
      const excerpt = stripHtmlToText(response.data?.data?.htmlContent || "");
      previewCache.set(documentName, excerpt);
      loadingPromises.delete(documentName);
      notifyPreviewListeners();
      return excerpt;
    })
    .catch(() => {
      previewCache.set(documentName, "");
      loadingPromises.delete(documentName);
      notifyPreviewListeners();
      return "";
    });

  loadingPromises.set(documentName, promise);
  return promise;
}

export function normalizeAcademySearchQuery(searchTerm) {
  return String(searchTerm || '').trim().toLowerCase();
}

export function documentTitleMatchesSearch(document, searchTerm) {
  const query = normalizeAcademySearchQuery(searchTerm);
  if (!query) return true;

  const title = String(document?.label || '').toLowerCase();
  return title.includes(query);
}

export function filterAcademyDocuments(documents, searchTerm) {
  const query = normalizeAcademySearchQuery(searchTerm);
  if (!query) return documents || [];

  return (documents || []).filter((document) => documentTitleMatchesSearch(document, searchTerm));
}

export function courseHasMatchingDocuments(course, searchTerm) {
  const query = normalizeAcademySearchQuery(searchTerm);
  if (!query) return false;

  return (course?.documents || []).some((document) => documentTitleMatchesSearch(document, searchTerm));
}
